import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import { Link } from 'gatsby';
import animationData from '../utils/2024-07-05_MoT_Logo-Header.json';

const LottieAnimation = ({ animationData }) => {
  const lottieRef = useRef(null);
  const animationInstance = useRef(null);

  useEffect(() => {
    // Initialize Lottie
    animationInstance.current = lottie.loadAnimation({
      container: lottieRef.current,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: animationData,
    });

    // Play the animation on load
    animationInstance.current.play();

    return () => {
      animationInstance.current.destroy();
    };
  }, [animationData]);

  return (
    <div
      ref={lottieRef}
      style={{ width: '180px' }}
      className="relative -top-1"
    ></div>
  );
};

const Logo = () => {
  useEffect(() => {
    const handlePageLoad = () => {
      const lottieElement = document.querySelector('lottie-player');
      if (lottieElement) {
        lottieElement.play();
      }
    };

    handlePageLoad();

    return () => {
      // Cleanup if necessary
    };
  }, []);

  // Check if the current URL is a subpage under /videos/
  const videoDetails =
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/videos/') &&
    !window.location.pathname.startsWith('/videos/list') && // Exclude /videos/list/
    window.location.pathname.split('/').filter(Boolean).length === 2; // Ensure it's exactly two parts: /videos/{slug}

  return (
    <Link
      to={videoDetails ? '/videos/list' : '/'}
      title="Home"
      className="logo block relative -left-6 md:-left-0 scale-[0.8] md:scale-[1] h-12 overflow-hidden"
    >
      <LottieAnimation animationData={animationData} />
    </Link>
  );
};

export default Logo;
